import { accountIsMyself } from '@/component/login/action';
import DialogModifyPwd from '@/component/login/login_v5/dialog-modify-pwd';
import DiaglogSwitchMerchant from '@/component/login/login_v5/dialog-switch-merchant';
import { loginOut, modifyPassword } from '@/component/login/login_v5/utils';
import store from '@/store';
import { QuestionCircleOutlined } from '@ant-design/icons';
import envHandler from '@lima/env-handler';
import { Button, Dropdown, Layout, Menu, Modal } from 'antd';
import * as React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import sensors from 'sa-sdk-javascript';
import { axios_ } from '../../tools/axios_';
import { CUSTOMIZED_FIRST_LEVEL_COMPANY_ID_LIST } from "../../tools/constants";
import {
    clearAllStorage,
    initPageNamesConfig,
    toLogin,
    Utils
} from '../../tools/utils';
import { getControlChannelRoots } from "../companymanager/ChannelManager/services";
import { LoginAction } from '../login/actions';
import { getLogoOptions, getUserPermissionInfoByCodeNoBff } from '../system/api/safety';
import NoticeMessage from '../system/noticeMessage/noticeMessage';
import { CommonAction } from './actions';
import './content.less';
import LockSvg from './img/lock.svg';
import ShutDown from './img/shut_down.svg';
import TriggerSvg from './img/trigger.svg';

const { Header } = Layout

class Headers extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      userName: '正在获取...', //用域名
      visible: false,
      loading: false,
      companyName: '', //子公司商户(供应商、商户)名称，用于欢迎语
      multiIdentity: false, // 是否有多个商户，用于判断是否展示切换商户
      switchMerchantVisible: false,
      switchMerchantLoading: false,
      pageNamesConfig: {} // 页面配置
    }
  }
  loginOutHandle=()=>{
    let token = JSON.parse(localStorage.getItem('platformTokenInfo') || '{}').access_token
    loginOut({token}).then(_=>{
         Utils.customTrack('MerchantTopbarClick', {
            element_content: '退出登录'
        })
        this.props.setToken(null)
        sessionStorage.clear() //清除缓存
        clearAllStorage()
        setTimeout(() => {
            toLogin() //跳转到登录页
        }, 1000);
    })

  }
  menus() {
    return (
      <Menu className='header-tools-menu-list' style={{ textAlign: 'center' }}>
        <Menu.Item key='accountSafety'>
          <Link
            to='/system/accountSafety'
            onClick={() => {
              // Utils.customTrack('MerchantTopbarClick', {
              //     element_content: '账号安全'
              // });
            }}
          >
            <img src={LockSvg} className='menu-icon' />
            账号安全
          </Link>
        </Menu.Item>
        {this.state && this.state.multiIdentity && (
          <Menu.Item key='multiIdentity'>
            <a
              onClick={_ => {
                // Utils.customTrack('MerchantTopbarClick', {
                //     element_content: '切换商户'
                // });
                this.setState({
                  switchMerchantVisible: true
                })
              }}
            >
              <img src={TriggerSvg} className='menu-icon' />
              切换商户
            </a>
          </Menu.Item>
        )}

        <Menu.Item key='loginOutHandle'>
          <a
            onClick={() => {
                this.loginOutHandle()
            }}
          >
            <img src={ShutDown} className='menu-icon' />
            退出登录
          </a>
        </Menu.Item>
      </Menu>
    )
  }

  componentDidMount() {
    // 初始化页面展示字段（合作案）
    initPageNamesConfig('header', '', this.props.token).then(res => {
      if (res.data.status === 200) {
        this.setState({ pageNamesConfig: res.data.data || {} })
      }
    })
    this.getUserMsg()
  }

  async getProductdockingSwitch() {
    const switchName = 'isOpenPlatformAccess'
    setTimeout(async () => {
      if (Utils.getOrgId()) {
        let productdockingFlag = await this.getSwitchStatus(switchName)
          const res = await getControlChannelRoots()
          const channelStatus = res.status === 200 && res.data
        /*
          开发对接 按钮展示条件
          1. productdockingFlag 为 true
          2. 基于 条件一 companyLevelId为10005(总部 顶级) 时展示
          3. 基于 条件一 companyLevelId为10006 并且 是特殊渠道 this.props.isOpenChannel
          4. 给限定的一级机构开通此功能
        */
        productdockingFlag =
          productdockingFlag &&
          (Utils.getUserData().companyLevelId === '10005' ||
            (Utils.getUserData().companyLevelId === '10006' &&
                channelStatus && CUSTOMIZED_FIRST_LEVEL_COMPANY_ID_LIST.includes(Utils.getCompanyId())))
        this.setState({
          productdockingFlag
        })
      } else {
        this.getProductdockingSwitch()
      }
    }, 300)
  }

  async getSwitchStatus(switchName = '') {
    const { data } = await axios_({
      url: `/openapi/dic/ref/getDicRef`,
      method: 'get',
      params: {
        dicType: 'orgSetting',
        parentDicKey: switchName,
        thirdPartyId: Utils.getOrgId()
      }
    })

    if (data.code === 10000) {
      return data.data.childDicKey === 'is' || data.data.childDicKey === 'yes'
    }
    return false
  }

  getUserMsg() {
    axios_({
      url: 'getUser',
      method: 'get',
      headers: {
        'access-token': this.props.token
      }
    })
      .then(async res => {
        let env = 'production'
        if (envHandler.isProd()) {
          env = 'production'
        } else if (envHandler.isStaging()) {
          env = 'staging'
        } else {
          env = 'test'
        }
        sessionStorage.setItem('name', res.data.orgNameJP || '')
        sessionStorage.setItem(
          'interestCalcType',
          res.data.interestCalcType || ''
        )
        const { companyId, userId } = res.data
        const {
          data: { logoUrl, defaultLogoUrl }
        } = await getLogoOptions(companyId, userId)
        sensors.login(`${env}_${res.data.userId}`)
        Utils.setUserData(res.data)
        localStorage.setItem('orgId', res.data.orgId)
        //将用户信息存储到Redux中
        this.props.setUserInfo({
            ...res.data,
          companyName: res.data.companyName ? res.data.companyName : '', //子公司商户
          logoUrl: logoUrl || defaultLogoUrl,
          defaultLogoUrl: defaultLogoUrl,
          logo_url: logoUrl,
          hasChangedLogo: Boolean(logoUrl)
        })
        //加入到状态管理中
        this.setState({
          userName: res.data.name,
          companyName: res.data.name ? res.data.name : '', //子公司商户，//如果商户类型为“2”，则名称统一修改为“系统”
          multiIdentity: res.data.numOfOrg > 1
        })
        this.getProductdockingSwitch();
        // 自媒体权限全局获取存放到状态管理中
        const resp = await getUserPermissionInfoByCodeNoBff({ userId: Utils.getUserId(), permissionCode: '151_001' });
        store.dispatch(accountIsMyself(resp.data.dataPermission));
      })
      .catch(e => {})
  }

  /** 当前页面是否为首页（统计页面）*/
  isHomePage = () => {
    let _pathName = this.props.location.pathname
      ? this.props.location.pathname
      : ''
    return (
      _pathName.indexOf('/homePage') >= 0 ||
      _pathName.indexOf('/productInfoList') >= 0
    ) //如果路径中包含“/homePage”,则认为当前页面为首页
  }

  render() {
    const { userName } = this.state
    return (
      <Header className='content_header'>
        {this.isHomePage() && (
          <span className='span_welcom'>
            {'尊敬的' + this.state.companyName + '，欢迎您!'}
          </span>
        )}
        {/* <Icon
          className='trigger'
          style={{ fontSize: 20, lineHeight: '64px' }}
        /> */}
        <div className='index_header_right'>
          { this.state.productdockingFlag && (
            <a
              className='product-docking'
              href='/productdocking'
              target='_blank'
              onClick={() => {
                Utils.customTrack('MerchantTopbarClick', {
                  element_content: '开发对接'
                })
              }}
            >
              <img src={require('../../assets/images/file_icon_b.png')} />{' '}
              &nbsp;开发对接
              {/*<Icon type="file-text" style={{fontSize:'16px'}}/> &nbsp;开发对接*/}
            </a>
          )}
          {!this.state.pageNamesConfig.noticeBtnCloseFlag && (
            <NoticeMessage
              onClick={() => {
                Utils.customTrack('MerchantTopbarClick', {
                  element_content: '通知'
                })
              }}
            />
          )}
          {/*<Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"/>*/}
          {!Utils.isHLB() && !this.state.pageNamesConfig.helpCenterCloseFlag && (
            <a
              className='help-center'
              href='https://www.yuque.com/books/share/ff108a79-500b-42e1-8d3a-32a967d8b60a/wn8eot'
              target='_blank'
              rel='noreferrer'
              onClick={() => {
                Utils.customTrack('MerchantTopbarClick', {
                  element_content: '帮助中心'
                })
              }}
            >
              <QuestionCircleOutlined style={{ fontSize: '16px' }} />{' '}
              &nbsp;帮助中心
            </a>
          )}
          <Dropdown dropdownRender={()=>this.menus()} placement='bottom'>
            <Button>{userName}</Button>
          </Dropdown>
        </div>
        {this.props.showMessage && (
          <div
            onClick={() => {
              this.props.setMessageStatus(false)
            }}
            style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              background: 'transparent',
              top: 0,
              left: 0,
              zIndex: 20
            }}
            className='mask'
          />
        )}

        <DialogModifyPwd
          visible={this.state.visible}
          loading={this.state.loading}
          onCancel={_ => this.setState({ visible: false, loading: false })}
          onOk={values => {
            console.log(values)
            this.setState({ loading: true })
            modifyPassword(values, {
              headers: {
                'access-token': this.props.token
              }
            })
              .then(res => {
                this.setState({ loading: false })
                if (res.status === 200) {
                  Modal.info({
                    title: '提示',
                    content: res.message || '修改密码成功，请重新登录',
                    okText: '返回登录页面',
                    onOk: () => {
                      toLogin() //跳转到登录页
                      //清空localStorage和redux中的token字段
                      clearAllStorage()
                      this.props.setToken(null)
                    }
                  })
                } else if (res.status < 400) {
                  Modal.warning({
                    title: '提示',
                    content: res.message || '密码修改失败'
                  })
                }
              })
              .catch(e => {
                Modal.error({
                  title: '操作失败，请稍后再试'
                })
                this.setState({ loading: false })
              })
          }}
        />
        <DiaglogSwitchMerchant
          visible={this.state.switchMerchantVisible}
          onCancel={_ =>
            this.setState({
              switchMerchantVisible: false,
              switchMerchantLoading: false
            })
          }
        ></DiaglogSwitchMerchant>
      </Header>
    );
  }
}

function mapState(state) {
  return {
    token: state.token,
    showMessage: state.showMessage,
    isOpenChannel: state.isOpenChannel
  }
}

const mapDispatch = {
  ...CommonAction,
  ...LoginAction
}

export default withRouter(connect(mapState, mapDispatch)(Headers))
